/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * CollapsedIcon - Auto-generated from icon.js
 */
export const CollapsedIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M9 14L13 10L9 6" stroke="#B9B9B9" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default CollapsedIcon;
